export const isGoogleMapsUrl = (url: string) => {
  const patterns = [
    /^https?:\/\/(www\.)?google\.[a-z.]+\/maps/i,
    /^https?:\/\/(maps\.)?google\.[a-z.]+\/maps/i,
    /^https?:\/\/goo\.gl\/maps\/[A-Za-z0-9]+/i,
    /^https?:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+/i,
    /^https?:\/\/maps\.google\.[a-z.]+\/\?.*[?&]?q=[^&]+/i,
    /^https?:\/\/(www\.)?google\.[a-z.]+\/maps\?.*[?&]q=[^&]+/i,
  ];
  return patterns.some((re) => re.test(url));
};
